import { ListContainer } from './ListContainer';
import { MyInfoUserOwnProductCard } from './MyInfoUserOwnProductCard';
import { UserOwnProductDetailCardWrapper } from '../../../../views/Product/listView/UserOwnProductDetailCard/UserOwnProductListDetailCardGroup';
import { useGetMyOwnTractors } from '../../../../hooks/api/user/queries/useGetMyOwnTractors';
import { AnimateLoading } from '../../../../components/common/loading/AnimateLoading';
import { MachineApprovalStatus } from '../../../../constants/machine/machine.constant';
import { PopupConfirmModal } from '../../../../components/common/modal/popup/PopupConfirmModal';
import { useState } from 'react';
import { IMyOwnTractor } from '../../../../interfaces/OwnTractor.interfaces';
import { ConfirmDeleteOwnTractorModal } from './ConfirmDeleteOwnTractorModal';

export const PublishedTractorListSection = ({ changeTabIndex }: { changeTabIndex: (index: number) => void }) => {
  const [selectedTractor, setSelectedTractor] = useState<IMyOwnTractor>();
  const [isPokePublicCancelModalOpen, setIsPokePublicCancelModalOpen] = useState(false);
  const UNPUBLISHED_TAB = 1;

  const { APPROVAL, PSWAITING } = MachineApprovalStatus;
  const {
    data: usersOwnTractors,
    isLoading: isGetUsersOwnTractorsLoading,
    refetch: refetchUsersOwnTractors,
  } = useGetMyOwnTractors({
    searchParam: { machineApprovalStatus: `${APPROVAL},${PSWAITING}`, isPokeEnabled: true },
  });

  const setPokeStatusToDisabled = (tractor: IMyOwnTractor) => {
    setIsPokePublicCancelModalOpen(true);
    setSelectedTractor(tractor);
  };

  const handlePokePublicCancelModalClose = () => {
    setIsPokePublicCancelModalOpen(false);
    changeTabIndex(UNPUBLISHED_TAB);
  };

  if (isGetUsersOwnTractorsLoading) {
    return <AnimateLoading />;
  }

  if (usersOwnTractors) {
    return (
      <>
        <ListContainer>
          {usersOwnTractors.map((tractor) => {
            if (!tractor || !tractor.machine) {
              return null;
            }

            return (
              <UserOwnProductDetailCardWrapper key={tractor.id}>
                <MyInfoUserOwnProductCard
                  userOwnProduct={tractor}
                  handlePokeAction={setPokeStatusToDisabled}
                  refetchList={refetchUsersOwnTractors}
                />
              </UserOwnProductDetailCardWrapper>
            );
          })}
        </ListContainer>
        <PopupConfirmModal
          isShow={isPokePublicCancelModalOpen}
          closeModal={() => {
            handlePokePublicCancelModalClose();
          }}
          title={'🔒 찔러보기 요청을 받지 않아요'}
          description={
            '이제부터 다른 고객님들께서\n보유하신 트랙터를 볼 수 없어요!\n\n다른 고객님들이 내 트랙터에\n관심이 있는지 궁금하다면\n‘찔러보기 요청 받기’ 버튼을 눌러주세요.'
          }
          buttonArray={[
            {
              text: '확인',
              onClick: () => {
                handlePokePublicCancelModalClose();
              },
              color: 'blue',
            },
          ]}
        />
      </>
    );
  }
  return <></>;
};
